import { Link } from "react-router-dom";
import { mediaList } from "@/mocks/media";

const collections = [
  {
    title: "高分电影榜",
    desc: "评分口碑双高的院线佳作精选",
    to: "/category/movie?sort=rating",
    ids: ["1", "3", "5", "10"],
  },
  {
    title: "经典电视剧推荐",
    desc: "值得反复回味的优质剧集",
    to: "/category/tv?sort=rating",
    ids: ["13", "19", "15", "16"],
  },
  {
    title: "科幻宇宙专题",
    desc: "星辰大海与未来世界的想象",
    to: "/category/movie?genre=科幻",
    ids: ["3", "8", "15", "22"],
  },
  {
    title: "武侠江湖专题",
    desc: "仗剑天涯，快意恩仇的江湖梦",
    to: "/category/tv?genre=武侠",
    ids: ["13", "19", "21", "7"],
  },
];

export default function Collections() {
  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">
              热门推荐专题
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              编辑精选主题影单，快速找到你想看的方向
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:gap-5 sm:grid-cols-2">
          {collections.map((col) => {
            const posters = mediaList.filter((m) => col.ids.includes(m.id)).slice(0, 4);
            return (
              <Link
                key={col.title}
                to={col.to}
                className="group block rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:border-accent-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-accent-700 transition-colors">
                      {col.title}
                    </h3>
                    <p className="mt-1 text-xs text-foreground-600">{col.desc}</p>
                  </div>
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
                <div className="mt-4 grid grid-cols-4 gap-2">
                  {posters.map((p) => (
                    <div
                      key={p.id}
                      className="aspect-[2/3] overflow-hidden rounded-md bg-background-200"
                    >
                      <img
                        src={p.poster}
                        alt={p.title}
                        className="h-full w-full object-cover object-top"
                      />
                    </div>
                  ))}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}